enum AudienceLogicState {
  Completed = 'C',
  Submitted = 'S',
  Unsubmitted = 'U',
}

export default AudienceLogicState;
